<template>
    <div v-touch:tap="onClicked" class="yah-logo">
        <label data-translation-element="yah">YAH</label>
        <icon name="yah"></icon>
    </div>
</template>

<script>
export default {
    methods: {
		onClicked () {
			this.$wayfinder.showKiosk();
            this.$emit("clicked");
		}
	}
}
</script>

<style lang="less" scoped>
    @import '../theme/variables';
    .yah-logo {
        text-transform: initial;
        line-height: 1.2;
        background-color: #fff;
        height: 3.2rem;
        border-radius: 0.4rem;
        padding: 1em;
        color: @action-color;
        display: flex;
        align-items: center;
        font-size: 0.8rem;

        label {
            margin-top: 0.2em;
        }
        
        .icon {
            margin-top: 0.1rem;
            margin-left: 0.5em;
            height: 1.3rem;
        }
    }
</style>